module.exports = __webpack_public_path__ + "img/img-4mobile.7720f9f5.webp";